import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"
import Infographic from "../../components/teach-infographic"


var image
var content = {
  hero: {
    title: (
      <span>
        Teach Cyber Security <br /> with Project Ares
      </span>
    ),
    text:<span>
      <h4 style={{margin:"0 0 .5em 0"}}>Educators, do you struggle to keep students engaged in the cyber security classroom?</h4>
      <h4 style={{margin:"0 0 .5em 0"}}>Are you looking for ways to make learning more hands-on so students build real-world skills?</h4>
      <h4 style={{margin:"0 0 .5em 0"}}>Have you considered using a cyber range for experiential learning lab within your course material?</h4>
      <p>Project Ares is an award-winning virtual cyber range combined with security learning scenarios suitable for remote or in-person teaching.</p>
    </span>  },

  calendly: {
    text:  <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
  },

  cta1: {
    title: "Align your Cyber Curriculum to Project Ares Today",
    text:
      "Build an Immersive Cyber Curriculum with Project Ares: A use Case",
    url:
      "https://marketing.circadence.com/acton/media/36273/immersive-cyber-curriculum-with-project-ares-use-case-university-of-colorado-boulder",
    cta: "Download Now",
  },

  cta2: {
    title: "Build career enabling skills. ",
    text:
      "Learn more about Project Ares as a hands-on teaching element for your cyber security curriculum.",
    url:
    "/project-ares",
    cta: "Learn More",
  },
  social: {
    social1: {
      
      title:"",
      
      text:<span>Short of some form of internship at an employer as a cybersecurity engineer, I cannot envision a better means of exposing learner’s to “real world” security work.<br/><span className="source">- Dr. James Barker,<br/> Capella University</span></span>,
    
     
      url: "/teach",
    },
  },
  //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources: {
    resource1: {
      title:<span>Conversation with a Cyber Educator<span>Webinar</span></span>,
      
      text:
        "How Capella University adopted hands-on learning in the cyber classroom. ",
        url: "https://marketing.circadence.com/acton/media/36273/webinar-how-capella-university-adopted-hands-on-learning-with-project-ares",
    },
    resource2: {
      title:<span>Modernizing Cyber Security Education at Calhan High School<span>Success Story</span></span>,
      
      text:
        "Project Ares helps address a gap between local education in cyber security and the key skills that business hiring managers were looking for in candidates.",
      url: "https://staging.circadence.com/wp-content/uploads/2020/04/Calhan-HS-success-story-Final.pdf",
    },
 

    resource3: {
      title:<span>Student and Teacher Testimonials of Project Ares in the Classroom<span>Infographic</span></span>,
     
      text:
        "Hear from collegiate professors, program directors, and students on how Project Ares enriched the cyber classroom experience. ",
        url: "https://staging.circadence.com/wp-content/uploads/2019/07/EDU-Testimonial-Infographic-v3_final_March2020.pdf",
    },



  },
  simple: {
    simple1: {
      text: "Enrich cyber security curriculum with built-in learning topics.",
    },
    simple2: {
      text:
        "Improve course enrollment thanks to gamified learning activities.",
    },
    simple3: {
      text:
        "Increase student retention with realistic cyber scenarios.",
    },
    simple4: {
      text:
        "Assess student performance against learning objectives.",
    },
    
  },
}

class TeachPage extends React.Component {
  render() {
    return (
      <Layout>
      <SEO title={seodata.teach.title} description={seodata.teach.description} keywords={seodata.teach.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name={"womanTeacher"} />}
        />

<Infographic/>
        <Calendly text={content.calendly.text} inv={true} bgColor={"yellow"} />

        <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
          url={content.cta1.url}
          inv={false}
          bgColor={"deep-blue"}
          image={"document"}
        />

        <SocialSlider>
          <SimpleSlide
            image={<HandleImages name={"peopleScreen"} />}
            title={content.social.social1.title}
            text={content.social.social1.text}
          />
        </SocialSlider>

 
        <h3>Additional Resources </h3>

        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"gamification"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"kidComputer"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"manWomanComputer"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
         
        </ResourcesWrapper>

        <SimpleSlider>
          <SimpleSlide
            image={<HandleImages name={"pAScreen1"} />}
            text={content.simple.simple1.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen2"} />}
            text={content.simple.simple2.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen4"} />}
            text={content.simple.simple3.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen6"} />}
            text={content.simple.simple4.text}
          />
         
        </SimpleSlider>
        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />

      </Layout>
    )
  }
}

export default TeachPage
